import { render, staticRenderFns } from "./aprobados.vue?vue&type=template&id=e2d6cedc&"
import script from "./aprobados.vue?vue&type=script&lang=js&"
export * from "./aprobados.vue?vue&type=script&lang=js&"
import style0 from "./aprobados.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports